import { render, staticRenderFns } from "./RoleCreateUpdate.vue?vue&type=template&id=7965a17c&"
import script from "./RoleCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./RoleCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports